// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Components
import Loading from './loading';

// Images
import _404 from './404.png';

// Styles
import './thumbnail.scss';

class Thumbnail extends Component {
    state = {
        loaded: false,
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        const {src} = this.props;

        if (src !== nextProps.src) {
            this.setState({loaded: false});
        }
    }

    getClass() {
        const {className} = this.props;

        return classnames(
            {
                'thumbnail--container': true,
            },
            className
        );
    }

    getProps() {
        const {maxWidth, altText, imgSrc, width} = this.props;

        return {
            className: 'thumbnail--image',
            onLoad: this.handleLoad,
            onClick: this.handleClick.bind(this),
            alt: altText,
            src: imgSrc,
            style: {
                width: width && width < maxWidth ? width : maxWidth,
            },
        };
    }

    handleLoad = () => {
        this.setState({loaded: true});
    };

    handleClick() {
        const {data, onClick} = this.props;

        onClick(data);
    }

    render() {
        const {title, label, loading} = this.props;
        const {loaded} = this.state;

        const loadingStatus = !loaded || loading;

        return (
            <div className={this.getClass()} style={{cursor: 'pointer'}} title={title}>
                <img
                    alt="HTTP 404 error"
                    {...this.getProps()}
                    onError={e => {
                        e.target.onerror = null;
                        e.target.src = _404;
                    }}
                />
                {label ? <label className="thumbnail--label">{label}</label> : null}
                <Loading className="thumbnail--loading" loading={loadingStatus} small={true} />
            </div>
        );
    }
}

Thumbnail.propTypes = {
    altText: PropTypes.string,
    className: PropTypes.string,
    data: PropTypes.object,
    height: PropTypes.number,
    imgSrc: PropTypes.string.isRequired,
    label: PropTypes.string,
    loading: PropTypes.bool,
    maxWidth: PropTypes.number,
    onClick: PropTypes.func,
    src: PropTypes.string,
    title: PropTypes.string,
    width: PropTypes.number,
};

Thumbnail.defaultProps = {
    maxWidth: 100,
};

export default Thumbnail;
